import { initializeApp } from 'firebase/app'
import { getMessaging } from 'firebase/messaging'

const firebaseConfig = {
  apiKey:            'AIzaSyCrj7Ra1gyszX-giTQ2gmx5eH61T6CcKxc',
  authDomain:        'ownorganizer.firebaseapp.com',
  projectId:         'ownorganizer',
  storageBucket:     'ownorganizer.firebasestorage.app',
  messagingSenderId: '293663116929',
  appId:             '1:293663116929:web:60c8d2668238b20bf98780',
}

const app = initializeApp(firebaseConfig)
export const messaging = getMessaging(app)
